import { signOut } from "firebase/auth"
import { FC, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useAuth } from "../hooks/use-firebase"

export const Logout: FC = ({ }) => {
  const auth = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    signOut(auth).then(() => {
      navigate("/login")
    })
  }, [auth, navigate])

  return (
    <div>
      logging out
    </div>
  )
}

